import { type Dtos, type FinancialPeriod } from "@inrev/common";
import {
	applyValuesToLeafLike,
	patchLineItemGroupView,
	renameLineItemGroupViewLabel,
} from "./applyFinancialViewValues";

export const patchIncomeStatementView = (
	view: FinancialPeriod.IncomeStatementView,
	body: Dtos.Admin.IncomeStatement.Update.Request,
): FinancialPeriod.IncomeStatementView => {
	if (body.field === "revenue") {
		return {
			...view,
			revenue: patchLineItemGroupView(view.revenue, body.label, body.values),
		};
	}

	const field = body.field;
	return {
		...view,
		[field]: applyValuesToLeafLike(view[field], body.values),
	};
};

export const renameIncomeStatementViewLabel = (
	view: FinancialPeriod.IncomeStatementView,
	oldLabel: string,
	newLabel: string,
): FinancialPeriod.IncomeStatementView => ({
	...view,
	revenue: renameLineItemGroupViewLabel(view.revenue, oldLabel, newLabel),
});
